import React from 'react'
import { toTitleCaseFromUnderscore } from '../../../../../lib/string'

export default function DiscountRuleRow({ rule }) {
  let source = "";
  if(rule.locations_by === 'by_state' && !rule.state_name) {
    source = 'All States'
  } else if(rule.locations_by === 'by_state' && rule.state_name) {
    source = rule.state_name
  } else if(rule.locations_by === 'by_location' && rule.location) {
    source = `${rule.location.display_name} ${rule.location.chain_number}, ${rule.location.city}, ${rule.location.state_code}`
  } else if(rule.locations_by === 'is_one9') {
    source = "All One9"
  } else if(rule.locations_by === 'is_express') {
    source = 'All Express'
  } else if(rule.locations_by === 'by_secondary_chain') {
    source = rule.secondary_chain.name
  }

  return (
    <tr>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {source}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {toTitleCaseFromUnderscore(rule.strategy)}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {rule.strategy == 'better_of' || rule.strategy == 'cost_plus' ? rule.cost_plus : null}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {rule.strategy == 'better_of' || rule.strategy == 'retail_minus' ? rule.retail_minus : null}
      </td>
    </tr>
  )
}
